import { __awaiter, __generator } from '../../node_modules/tslib/tslib.es6.js';
import React, { useState, useRef, useEffect } from 'react';
import classNames from 'classnames';
import styles from './Flag.module.scss.js';

function __variableDynamicImportRuntime0__(path) {
  switch (path) {
    case './flagicons/ad.svg': return import('./flagicons/ad.svg.js');
    case './flagicons/ae.svg': return import('./flagicons/ae.svg.js');
    case './flagicons/af.svg': return import('./flagicons/af.svg.js');
    case './flagicons/ag.svg': return import('./flagicons/ag.svg.js');
    case './flagicons/ai.svg': return import('./flagicons/ai.svg.js');
    case './flagicons/al.svg': return import('./flagicons/al.svg.js');
    case './flagicons/am.svg': return import('./flagicons/am.svg.js');
    case './flagicons/ao.svg': return import('./flagicons/ao.svg.js');
    case './flagicons/aq.svg': return import('./flagicons/aq.svg.js');
    case './flagicons/ar.svg': return import('./flagicons/ar.svg.js');
    case './flagicons/arab.svg': return import('./flagicons/arab.svg.js');
    case './flagicons/as.svg': return import('./flagicons/as.svg.js');
    case './flagicons/at.svg': return import('./flagicons/at.svg.js');
    case './flagicons/au.svg': return import('./flagicons/au.svg.js');
    case './flagicons/aw.svg': return import('./flagicons/aw.svg.js');
    case './flagicons/ax.svg': return import('./flagicons/ax.svg.js');
    case './flagicons/az.svg': return import('./flagicons/az.svg.js');
    case './flagicons/ba.svg': return import('./flagicons/ba.svg.js');
    case './flagicons/bb.svg': return import('./flagicons/bb.svg.js');
    case './flagicons/bd.svg': return import('./flagicons/bd.svg.js');
    case './flagicons/bf.svg': return import('./flagicons/bf.svg.js');
    case './flagicons/bg.svg': return import('./flagicons/bg.svg.js');
    case './flagicons/bh.svg': return import('./flagicons/bh.svg.js');
    case './flagicons/bi.svg': return import('./flagicons/bi.svg.js');
    case './flagicons/bj.svg': return import('./flagicons/bj.svg.js');
    case './flagicons/bl.svg': return import('./flagicons/bl.svg.js');
    case './flagicons/bm.svg': return import('./flagicons/bm.svg.js');
    case './flagicons/bn.svg': return import('./flagicons/bn.svg.js');
    case './flagicons/bo.svg': return import('./flagicons/bo.svg.js');
    case './flagicons/bq.svg': return import('./flagicons/bq.svg.js');
    case './flagicons/br.svg': return import('./flagicons/br.svg.js');
    case './flagicons/bs.svg': return import('./flagicons/bs.svg.js');
    case './flagicons/bt.svg': return import('./flagicons/bt.svg.js');
    case './flagicons/bv.svg': return import('./flagicons/bv.svg.js');
    case './flagicons/bw.svg': return import('./flagicons/bw.svg.js');
    case './flagicons/by.svg': return import('./flagicons/by.svg.js');
    case './flagicons/bz.svg': return import('./flagicons/bz.svg.js');
    case './flagicons/ca.svg': return import('./flagicons/ca.svg.js');
    case './flagicons/cc.svg': return import('./flagicons/cc.svg.js');
    case './flagicons/cd.svg': return import('./flagicons/cd.svg.js');
    case './flagicons/cefta.svg': return import('./flagicons/cefta.svg.js');
    case './flagicons/cf.svg': return import('./flagicons/cf.svg.js');
    case './flagicons/cg.svg': return import('./flagicons/cg.svg.js');
    case './flagicons/ch.svg': return import('./flagicons/ch.svg.js');
    case './flagicons/ci.svg': return import('./flagicons/ci.svg.js');
    case './flagicons/ck.svg': return import('./flagicons/ck.svg.js');
    case './flagicons/cl.svg': return import('./flagicons/cl.svg.js');
    case './flagicons/cm.svg': return import('./flagicons/cm.svg.js');
    case './flagicons/cn.svg': return import('./flagicons/cn.svg.js');
    case './flagicons/co.svg': return import('./flagicons/co.svg.js');
    case './flagicons/cp.svg': return import('./flagicons/cp.svg.js');
    case './flagicons/cr.svg': return import('./flagicons/cr.svg.js');
    case './flagicons/cu.svg': return import('./flagicons/cu.svg.js');
    case './flagicons/cv.svg': return import('./flagicons/cv.svg.js');
    case './flagicons/cw.svg': return import('./flagicons/cw.svg.js');
    case './flagicons/cx.svg': return import('./flagicons/cx.svg.js');
    case './flagicons/cy.svg': return import('./flagicons/cy.svg.js');
    case './flagicons/cz.svg': return import('./flagicons/cz.svg.js');
    case './flagicons/de.svg': return import('./flagicons/de.svg.js');
    case './flagicons/dg.svg': return import('./flagicons/dg.svg.js');
    case './flagicons/dj.svg': return import('./flagicons/dj.svg.js');
    case './flagicons/dk.svg': return import('./flagicons/dk.svg.js');
    case './flagicons/dm.svg': return import('./flagicons/dm.svg.js');
    case './flagicons/do.svg': return import('./flagicons/do.svg.js');
    case './flagicons/dz.svg': return import('./flagicons/dz.svg.js');
    case './flagicons/eac.svg': return import('./flagicons/eac.svg.js');
    case './flagicons/ec.svg': return import('./flagicons/ec.svg.js');
    case './flagicons/ee.svg': return import('./flagicons/ee.svg.js');
    case './flagicons/eg.svg': return import('./flagicons/eg.svg.js');
    case './flagicons/eh.svg': return import('./flagicons/eh.svg.js');
    case './flagicons/er.svg': return import('./flagicons/er.svg.js');
    case './flagicons/es-ct.svg': return import('./flagicons/es-ct.svg.js');
    case './flagicons/es-ga.svg': return import('./flagicons/es-ga.svg.js');
    case './flagicons/es-pv.svg': return import('./flagicons/es-pv.svg.js');
    case './flagicons/es.svg': return import('./flagicons/es.svg.js');
    case './flagicons/et.svg': return import('./flagicons/et.svg.js');
    case './flagicons/eu.svg': return import('./flagicons/eu.svg.js');
    case './flagicons/fi.svg': return import('./flagicons/fi.svg.js');
    case './flagicons/fj.svg': return import('./flagicons/fj.svg.js');
    case './flagicons/fk.svg': return import('./flagicons/fk.svg.js');
    case './flagicons/fm.svg': return import('./flagicons/fm.svg.js');
    case './flagicons/fo.svg': return import('./flagicons/fo.svg.js');
    case './flagicons/fr.svg': return import('./flagicons/fr.svg.js');
    case './flagicons/frbe,nlbe.svg': return import('./flagicons/frbe_nlbe.svg.js');
    case './flagicons/ga.svg': return import('./flagicons/ga.svg.js');
    case './flagicons/gb-eng.svg': return import('./flagicons/gb-eng.svg.js');
    case './flagicons/gb-nir.svg': return import('./flagicons/gb-nir.svg.js');
    case './flagicons/gb-sct.svg': return import('./flagicons/gb-sct.svg.js');
    case './flagicons/gb-wls.svg': return import('./flagicons/gb-wls.svg.js');
    case './flagicons/gd.svg': return import('./flagicons/gd.svg.js');
    case './flagicons/ge.svg': return import('./flagicons/ge.svg.js');
    case './flagicons/gf.svg': return import('./flagicons/gf.svg.js');
    case './flagicons/gg.svg': return import('./flagicons/gg.svg.js');
    case './flagicons/gh.svg': return import('./flagicons/gh.svg.js');
    case './flagicons/gi.svg': return import('./flagicons/gi.svg.js');
    case './flagicons/gl.svg': return import('./flagicons/gl.svg.js');
    case './flagicons/gm.svg': return import('./flagicons/gm.svg.js');
    case './flagicons/gn.svg': return import('./flagicons/gn.svg.js');
    case './flagicons/gp.svg': return import('./flagicons/gp.svg.js');
    case './flagicons/gq.svg': return import('./flagicons/gq.svg.js');
    case './flagicons/gr.svg': return import('./flagicons/gr.svg.js');
    case './flagicons/gs.svg': return import('./flagicons/gs.svg.js');
    case './flagicons/gt.svg': return import('./flagicons/gt.svg.js');
    case './flagicons/gu.svg': return import('./flagicons/gu.svg.js');
    case './flagicons/gw.svg': return import('./flagicons/gw.svg.js');
    case './flagicons/gy.svg': return import('./flagicons/gy.svg.js');
    case './flagicons/hk.svg': return import('./flagicons/hk.svg.js');
    case './flagicons/hm.svg': return import('./flagicons/hm.svg.js');
    case './flagicons/hn.svg': return import('./flagicons/hn.svg.js');
    case './flagicons/hr.svg': return import('./flagicons/hr.svg.js');
    case './flagicons/ht.svg': return import('./flagicons/ht.svg.js');
    case './flagicons/hu.svg': return import('./flagicons/hu.svg.js');
    case './flagicons/ic.svg': return import('./flagicons/ic.svg.js');
    case './flagicons/id.svg': return import('./flagicons/id.svg.js');
    case './flagicons/ie.svg': return import('./flagicons/ie.svg.js');
    case './flagicons/il.svg': return import('./flagicons/il.svg.js');
    case './flagicons/im.svg': return import('./flagicons/im.svg.js');
    case './flagicons/in.svg': return import('./flagicons/in.svg.js');
    case './flagicons/io.svg': return import('./flagicons/io.svg.js');
    case './flagicons/iq.svg': return import('./flagicons/iq.svg.js');
    case './flagicons/ir.svg': return import('./flagicons/ir.svg.js');
    case './flagicons/is.svg': return import('./flagicons/is.svg.js');
    case './flagicons/it.svg': return import('./flagicons/it.svg.js');
    case './flagicons/je.svg': return import('./flagicons/je.svg.js');
    case './flagicons/jm.svg': return import('./flagicons/jm.svg.js');
    case './flagicons/jo.svg': return import('./flagicons/jo.svg.js');
    case './flagicons/jp.svg': return import('./flagicons/jp.svg.js');
    case './flagicons/ke.svg': return import('./flagicons/ke.svg.js');
    case './flagicons/kg.svg': return import('./flagicons/kg.svg.js');
    case './flagicons/kh.svg': return import('./flagicons/kh.svg.js');
    case './flagicons/ki.svg': return import('./flagicons/ki.svg.js');
    case './flagicons/km.svg': return import('./flagicons/km.svg.js');
    case './flagicons/kn.svg': return import('./flagicons/kn.svg.js');
    case './flagicons/kp.svg': return import('./flagicons/kp.svg.js');
    case './flagicons/kr.svg': return import('./flagicons/kr.svg.js');
    case './flagicons/kw.svg': return import('./flagicons/kw.svg.js');
    case './flagicons/ky.svg': return import('./flagicons/ky.svg.js');
    case './flagicons/kz.svg': return import('./flagicons/kz.svg.js');
    case './flagicons/la.svg': return import('./flagicons/la.svg.js');
    case './flagicons/lb.svg': return import('./flagicons/lb.svg.js');
    case './flagicons/lc.svg': return import('./flagicons/lc.svg.js');
    case './flagicons/li.svg': return import('./flagicons/li.svg.js');
    case './flagicons/lk.svg': return import('./flagicons/lk.svg.js');
    case './flagicons/lr.svg': return import('./flagicons/lr.svg.js');
    case './flagicons/ls.svg': return import('./flagicons/ls.svg.js');
    case './flagicons/lt.svg': return import('./flagicons/lt.svg.js');
    case './flagicons/lu.svg': return import('./flagicons/lu.svg.js');
    case './flagicons/lv.svg': return import('./flagicons/lv.svg.js');
    case './flagicons/ly.svg': return import('./flagicons/ly.svg.js');
    case './flagicons/ma.svg': return import('./flagicons/ma.svg.js');
    case './flagicons/mc.svg': return import('./flagicons/mc.svg.js');
    case './flagicons/md.svg': return import('./flagicons/md.svg.js');
    case './flagicons/me.svg': return import('./flagicons/me.svg.js');
    case './flagicons/mf.svg': return import('./flagicons/mf.svg.js');
    case './flagicons/mg.svg': return import('./flagicons/mg.svg.js');
    case './flagicons/mh.svg': return import('./flagicons/mh.svg.js');
    case './flagicons/mk.svg': return import('./flagicons/mk.svg.js');
    case './flagicons/ml.svg': return import('./flagicons/ml.svg.js');
    case './flagicons/mm.svg': return import('./flagicons/mm.svg.js');
    case './flagicons/mn.svg': return import('./flagicons/mn.svg.js');
    case './flagicons/mo.svg': return import('./flagicons/mo.svg.js');
    case './flagicons/mp.svg': return import('./flagicons/mp.svg.js');
    case './flagicons/mq.svg': return import('./flagicons/mq.svg.js');
    case './flagicons/mr.svg': return import('./flagicons/mr.svg.js');
    case './flagicons/ms.svg': return import('./flagicons/ms.svg.js');
    case './flagicons/mt.svg': return import('./flagicons/mt.svg.js');
    case './flagicons/mu.svg': return import('./flagicons/mu.svg.js');
    case './flagicons/mv.svg': return import('./flagicons/mv.svg.js');
    case './flagicons/mw.svg': return import('./flagicons/mw.svg.js');
    case './flagicons/mx.svg': return import('./flagicons/mx.svg.js');
    case './flagicons/my.svg': return import('./flagicons/my.svg.js');
    case './flagicons/mz.svg': return import('./flagicons/mz.svg.js');
    case './flagicons/na.svg': return import('./flagicons/na.svg.js');
    case './flagicons/nc.svg': return import('./flagicons/nc.svg.js');
    case './flagicons/ne.svg': return import('./flagicons/ne.svg.js');
    case './flagicons/nf.svg': return import('./flagicons/nf.svg.js');
    case './flagicons/ng.svg': return import('./flagicons/ng.svg.js');
    case './flagicons/ni.svg': return import('./flagicons/ni.svg.js');
    case './flagicons/nl.svg': return import('./flagicons/nl.svg.js');
    case './flagicons/no.svg': return import('./flagicons/no.svg.js');
    case './flagicons/np.svg': return import('./flagicons/np.svg.js');
    case './flagicons/nr.svg': return import('./flagicons/nr.svg.js');
    case './flagicons/nu.svg': return import('./flagicons/nu.svg.js');
    case './flagicons/nz.svg': return import('./flagicons/nz.svg.js');
    case './flagicons/om.svg': return import('./flagicons/om.svg.js');
    case './flagicons/pa.svg': return import('./flagicons/pa.svg.js');
    case './flagicons/pc.svg': return import('./flagicons/pc.svg.js');
    case './flagicons/pe.svg': return import('./flagicons/pe.svg.js');
    case './flagicons/pf.svg': return import('./flagicons/pf.svg.js');
    case './flagicons/pg.svg': return import('./flagicons/pg.svg.js');
    case './flagicons/ph.svg': return import('./flagicons/ph.svg.js');
    case './flagicons/pk.svg': return import('./flagicons/pk.svg.js');
    case './flagicons/pl.svg': return import('./flagicons/pl.svg.js');
    case './flagicons/pm.svg': return import('./flagicons/pm.svg.js');
    case './flagicons/pn.svg': return import('./flagicons/pn.svg.js');
    case './flagicons/pr.svg': return import('./flagicons/pr.svg.js');
    case './flagicons/ps.svg': return import('./flagicons/ps.svg.js');
    case './flagicons/pt.svg': return import('./flagicons/pt.svg.js');
    case './flagicons/pw.svg': return import('./flagicons/pw.svg.js');
    case './flagicons/py.svg': return import('./flagicons/py.svg.js');
    case './flagicons/qa.svg': return import('./flagicons/qa.svg.js');
    case './flagicons/re.svg': return import('./flagicons/re.svg.js');
    case './flagicons/ro.svg': return import('./flagicons/ro.svg.js');
    case './flagicons/rs.svg': return import('./flagicons/rs.svg.js');
    case './flagicons/ru.svg': return import('./flagicons/ru.svg.js');
    case './flagicons/rw.svg': return import('./flagicons/rw.svg.js');
    case './flagicons/sa.svg': return import('./flagicons/sa.svg.js');
    case './flagicons/sb.svg': return import('./flagicons/sb.svg.js');
    case './flagicons/sc.svg': return import('./flagicons/sc.svg.js');
    case './flagicons/sd.svg': return import('./flagicons/sd.svg.js');
    case './flagicons/se.svg': return import('./flagicons/se.svg.js');
    case './flagicons/sg.svg': return import('./flagicons/sg.svg.js');
    case './flagicons/sh-ac.svg': return import('./flagicons/sh-ac.svg.js');
    case './flagicons/sh-hl.svg': return import('./flagicons/sh-hl.svg.js');
    case './flagicons/sh-ta.svg': return import('./flagicons/sh-ta.svg.js');
    case './flagicons/sh.svg': return import('./flagicons/sh.svg.js');
    case './flagicons/si.svg': return import('./flagicons/si.svg.js');
    case './flagicons/sj.svg': return import('./flagicons/sj.svg.js');
    case './flagicons/sk.svg': return import('./flagicons/sk.svg.js');
    case './flagicons/sl.svg': return import('./flagicons/sl.svg.js');
    case './flagicons/sm.svg': return import('./flagicons/sm.svg.js');
    case './flagicons/sn.svg': return import('./flagicons/sn.svg.js');
    case './flagicons/so.svg': return import('./flagicons/so.svg.js');
    case './flagicons/sr.svg': return import('./flagicons/sr.svg.js');
    case './flagicons/ss.svg': return import('./flagicons/ss.svg.js');
    case './flagicons/st.svg': return import('./flagicons/st.svg.js');
    case './flagicons/sv.svg': return import('./flagicons/sv.svg.js');
    case './flagicons/sx.svg': return import('./flagicons/sx.svg.js');
    case './flagicons/sy.svg': return import('./flagicons/sy.svg.js');
    case './flagicons/sz.svg': return import('./flagicons/sz.svg.js');
    case './flagicons/tc.svg': return import('./flagicons/tc.svg.js');
    case './flagicons/td.svg': return import('./flagicons/td.svg.js');
    case './flagicons/tf.svg': return import('./flagicons/tf.svg.js');
    case './flagicons/tg.svg': return import('./flagicons/tg.svg.js');
    case './flagicons/th.svg': return import('./flagicons/th.svg.js');
    case './flagicons/tj.svg': return import('./flagicons/tj.svg.js');
    case './flagicons/tk.svg': return import('./flagicons/tk.svg.js');
    case './flagicons/tl.svg': return import('./flagicons/tl.svg.js');
    case './flagicons/tm.svg': return import('./flagicons/tm.svg.js');
    case './flagicons/tn.svg': return import('./flagicons/tn.svg.js');
    case './flagicons/to.svg': return import('./flagicons/to.svg.js');
    case './flagicons/tr.svg': return import('./flagicons/tr.svg.js');
    case './flagicons/tt.svg': return import('./flagicons/tt.svg.js');
    case './flagicons/tv.svg': return import('./flagicons/tv.svg.js');
    case './flagicons/tw.svg': return import('./flagicons/tw.svg.js');
    case './flagicons/tz.svg': return import('./flagicons/tz.svg.js');
    case './flagicons/ua.svg': return import('./flagicons/ua.svg.js');
    case './flagicons/ug.svg': return import('./flagicons/ug.svg.js');
    case './flagicons/uk.svg': return import('./flagicons/uk.svg.js');
    case './flagicons/um.svg': return import('./flagicons/um.svg.js');
    case './flagicons/un.svg': return import('./flagicons/un.svg.js');
    case './flagicons/us.svg': return import('./flagicons/us.svg.js');
    case './flagicons/uy.svg': return import('./flagicons/uy.svg.js');
    case './flagicons/uz.svg': return import('./flagicons/uz.svg.js');
    case './flagicons/va.svg': return import('./flagicons/va.svg.js');
    case './flagicons/vc.svg': return import('./flagicons/vc.svg.js');
    case './flagicons/ve.svg': return import('./flagicons/ve.svg.js');
    case './flagicons/vg.svg': return import('./flagicons/vg.svg.js');
    case './flagicons/vi.svg': return import('./flagicons/vi.svg.js');
    case './flagicons/vn.svg': return import('./flagicons/vn.svg.js');
    case './flagicons/vu.svg': return import('./flagicons/vu.svg.js');
    case './flagicons/wf.svg': return import('./flagicons/wf.svg.js');
    case './flagicons/ws.svg': return import('./flagicons/ws.svg.js');
    case './flagicons/xk.svg': return import('./flagicons/xk.svg.js');
    case './flagicons/xx.svg': return import('./flagicons/xx.svg.js');
    case './flagicons/ye.svg': return import('./flagicons/ye.svg.js');
    case './flagicons/yt.svg': return import('./flagicons/yt.svg.js');
    case './flagicons/za.svg': return import('./flagicons/za.svg.js');
    case './flagicons/zm.svg': return import('./flagicons/zm.svg.js');
    case './flagicons/zw.svg': return import('./flagicons/zw.svg.js');
    default: return new Promise(function(resolve, reject) {
      (typeof queueMicrotask === 'function' ? queueMicrotask : setTimeout)(
        reject.bind(null, new Error("Unknown variable dynamic import: " + path))
      );
    })
   }
 }
var Flag = function (_a) {
    var country = _a.country, className = _a.className, lazyLoadImgWhenScolling = _a.lazyLoadImgWhenScolling;
    var _b = useState(''), path = _b[0], setPath = _b[1];
    var imgRef = useRef(null);
    var getPathLazy = function () { return __awaiter(void 0, void 0, void 0, function () {
        var flagIcon, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!country)
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, __variableDynamicImportRuntime0__("./flagicons/".concat(country === null || country === void 0 ? void 0 : country.toLowerCase(), ".svg"))];
                case 2:
                    flagIcon = _a.sent();
                    setPath(flagIcon.default);
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    console.error(e_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        var observer = new IntersectionObserver(function (entries) {
            if (entries[0].isIntersecting) {
                getPathLazy();
                observer.disconnect();
            }
        });
        if (imgRef.current) {
            observer.observe(imgRef.current);
        }
        return function () {
            if (imgRef.current) {
                observer.unobserve(imgRef.current);
            }
        };
    }, [imgRef]);
    useEffect(function () {
        if (!lazyLoadImgWhenScolling) {
            getPathLazy();
        }
    }, [country]);
    if (!country)
        return React.createElement("div", { className: styles.fi });
    return (React.createElement("img", { id: "countryFlag", ref: imgRef, src: path !== null && path !== void 0 ? path : '', alt: "country flag", className: classNames(styles.fi, className) }));
};
Flag.defaultProps = {
    lazyLoadImgWhenScolling: false,
};

export { Flag as default };
